import apiError from './api-error';
import apiTimeUpdated from './api-time-updated';
import translate from './translate';
import event from './event';
import contests from './contests';
import contestsById from './contests-by-id';
import athletes from './athletes';
import round from './round';
import roundSelection from './round-selection';
import heats from './heats';
import heatsById from './heats-by-id';
import heatId from './heat-id';
import colors from './colors';
import countdown from './countdown';
import isLive from './is-live';
import selectedAthleteId from './selected-athlete-id';
import popup from './popup';

export default {
    apiError,
    apiTimeUpdated,
    translate,
    event,
    contests,
    contestsById,
    athletes,
    round,
    roundSelection,
    heats,
    heatsById,
    heatId,
    colors,
    countdown,
    isLive,
    selectedAthleteId,
    popup
};



// WEBPACK FOOTER //
// ./src/store/reducers/index.js